import React, { useEffect, useState } from "react";
import { makeStyles, InputLabel, TextField } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    label: {
        marginBottom: '12px'
    },
    input: {
        '& input[type=number]': {
            '-moz-appearance': 'textfield'
        },
        '& input[type=number]::-webkit-outer-spin-button': {
            '-webkit-appearance': 'none',
            margin: '0'
        },
        '& input[type=number]::-webkit-inner-spin-button': {
            '-webkit-appearance': 'none',
            margin: '0'
        }
    },
}));

export default function InputNumber(props) {
    const classes = useStyles();
    const [invalidChars, setInvalidChars] = useState([
        "-",
        "+",
        "e"
    ]);

    useEffect(() => {
        if (!props.allowDecimal) {
            setInvalidChars([
                "-",
                "+",
                "e",
                "."
            ])
        }
    }, [props.allowDecimal])


    return (
        <>
            {props.label ? <InputLabel htmlFor={props.id} className={classes.label}>{props.label}</InputLabel> : null}
            <TextField
                type="number"
                fullWidth = {props.fullWidth}
                size = {props.size}
                disabled = {props.disabled}
                id={props.id}
                className={classes.input}
                value={props.value ? props.value : ''}
                onKeyDown={(e) => {
                    if (invalidChars.includes(e.key)) {
                        e.preventDefault();
                    }
                }}
                onChange={(e) => { props.onChange(parseInt(e.target.value)) }}
                onBlur={(e) => { props.hasOwnProperty("onBlur") && props.onBlur(parseInt(e.target.value))}}
                variant="outlined"
                error={props.hasError}
                helperText={props.errorText}
            />
        </>
    )
}